var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSharepoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#036C70",
  d: "M12.279 13.394a6.697 6.697 0 1 0 0-13.395 6.697 6.697 0 0 0 0 13.395"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A9BA1",
  d: "M17.86 18.975a6.14 6.14 0 1 0 .001-12.278 6.14 6.14 0 0 0 0 12.278"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#37C6D0",
  d: "M13.116 23.44a4.744 4.744 0 1 0 0-9.488 4.744 4.744 0 0 0 0 9.487"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.395 6.044v11.91a1.027 1.027 0 0 1-1.021 1.02H8.378c-.006-.094-.006-.183-.006-.278a2 2 0 0 1 .011-.28 4.73 4.73 0 0 1 2.841-4.068V13.31a6.69 6.69 0 0 1-5.548-7.73q.042-.281.117-.557h6.58c.564.002 1.02.458 1.022 1.021",
  opacity: 0.1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.816 5.58h-6.14a6.69 6.69 0 0 0 5.805 7.767c-1.73.82-2.991 3.15-3.098 5.07q-.014.139-.011.279c0 .095 0 .184.005.279q.015.281.073.558h3.365a1.027 1.027 0 0 0 1.022-1.021V6.602a1.025 1.025 0 0 0-1.021-1.021",
  opacity: 0.2
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.816 5.58h-6.14a6.69 6.69 0 0 0 5.698 7.753c-1.675.88-2.886 3.204-2.99 5.084h3.432a1.03 1.03 0 0 0 1.021-1.022V6.602a1.025 1.025 0 0 0-1.021-1.021",
  opacity: 0.2
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.258 5.58H5.676a6.69 6.69 0 0 0 4.951 7.609 9.22 9.22 0 0 0-2.244 5.228h2.875a1.025 1.025 0 0 0 1.021-1.022V6.602c0-.564-.457-1.02-1.021-1.021",
  opacity: 0.2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#sharepoint_svg__a)",
  d: "M1.023 5.58h10.233c.565 0 1.023.459 1.023 1.024v10.232c0 .565-.458 1.023-1.023 1.023H1.023A1.023 1.023 0 0 1 0 16.836V6.604C0 6.039.458 5.58 1.023 5.58"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.57 11.595a1.9 1.9 0 0 1-.586-.62 1.7 1.7 0 0 1-.204-.846c-.012-.4.123-.79.38-1.096.269-.307.618-.535 1.007-.658.444-.146.91-.218 1.377-.213a5.2 5.2 0 0 1 1.814.254V9.7a2.8 2.8 0 0 0-.82-.335 4 4 0 0 0-.96-.115c-.34-.013-.68.059-.986.208a.65.65 0 0 0-.39.593.6.6 0 0 0 .167.42c.128.133.28.24.446.319a14 14 0 0 0 .957.418q.55.215 1.056.52c.255.157.469.373.624.629.16.29.236.618.223.948.018.41-.107.814-.355 1.142a2 2 0 0 1-.949.639 4.3 4.3 0 0 1-1.353.196 7 7 0 0 1-1.227-.1 4.2 4.2 0 0 1-.996-.293v-1.353c.305.217.645.38 1.005.48q.542.168 1.109.177a1.9 1.9 0 0 0 1.004-.213.67.67 0 0 0 .343-.602.64.64 0 0 0-.19-.461 1.9 1.9 0 0 0-.523-.365 18 18 0 0 0-.986-.441 5.6 5.6 0 0 1-.987-.516"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sharepoint_svg__a",
  x1: 2.133,
  x2: 10.145,
  y1: 4.782,
  y2: 18.659,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#058F92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#038489"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#026D71"
})))));
export { SvgSharepoint as ReactComponent };
export default __webpack_public_path__ + "static/media/sharepoint.59b9dd4c.svg";